const promiseTimeout = function(promise, timeOutError, promiseRejectError, milliSeconds) {
  //modify this to 500 after testing all the flows
  const ms = 6000;
  let id;
  const timeout = new Promise((resolve, reject) => {
    id = setTimeout(() => {
      clearTimeout(id);
      resolve(timeOutError);
      reject(promiseRejectError);
    }, milliSeconds || ms);
  });
  return Promise.race([promise, timeout]);
};

export default promiseTimeout;
